<template>
  <div
    class="transaction"
    :class="{
      'empty': !transaction.owner_id,
      'arranger_is_fixed': SCROLL_STATES.Filters_block_is_fixed,
      [getIconStyleClass]: true,
      [getMultiBillClass]: true,
      [getBillTypeClass]: true,
    }"
  >
    <div class="transaction-title">{{ $t('transaction.information') }}</div>

    <template v-if="!transaction.owner_id">
      <template v-if="isPersonalProject">
        <telegram-information-panel v-if="!MERCHANT_INFO.botSigned" />
        <report-information-panel />
        <widget-information-panel />
      </template>

      <template v-else>
        <div v-if="TRANSACTIONS.result.length > 0" class="choose-transaction">
          <p v-html="$t('select.transaction.details')"></p>
        </div>
      </template>
    </template>

    <!-- ТРАНЗАКЦИИ -->
    <!-- TODO: это полная параша, но пока только так не ломается и на айфонах и на десктопах -->
    <div
      v-else-if="isIOS"
      v-scrollbar="{
        id: `scroll-transaction-${transaction.public_id}`
      }"
      class="transaction_block"
    >
      <cs-scrollbar-vertical
        :id="`scroll-transaction-${transaction.public_id}`"
        class="scroll-transaction"
      />

      <!-- ФИЛЬТР: ПЕРЕВОДЫ -->
      <template v-if="transactionTypeIs(transaction, 'orders')">
        <transfer-transaction-details
          :transaction="transaction"
          :permission="isPersonalProject"
          @close="CLOSE_TRANSACTION"
        />
      </template>

      <template v-if="transactionTypeIs(transaction, 'partner')">
        <partner-transaction-details
          :transaction="transaction"
          :permission="isPersonalProject"
          @close="CLOSE_TRANSACTION"
        />
      </template>

      <!-- ФИЛЬТР: СЧЕТА -->
      <template v-if="transactionTypeIs(transaction, 'bills')">
        <bill-card-header :transaction="transaction" :permission="isPersonalProject" />
        <bill-card-content :transaction="transaction" :permission="isPersonalProject" />
        <bill-card-footer v-if="isPersonalProject" :transaction="transaction" :permission="isPersonalProject" />
      </template>

      <!-- ФИЛЬТР: ВЫВОД СРЕДСТВ -->
      <template v-if="transactionTypeIs(transaction, 'payoutsAndRefunds')">
        <div class="transaction_header">
          <button class="transaction_block-close" @click="CLOSE_TRANSACTION">
            {{ $t('common.close') }}
          </button>

          <div class="transaction_header-title">
            {{ getTextByOrderType(transaction.type) }} — {{ transaction.created_at | date('DD.MM.YYYY HH:mm') }}
            <template v-if="transaction.public_parent_id && transaction.type === 'REFUND'">
              <br/> {{ $t('for.transfer.number', { publicId: transaction.public_parent_id }) }}
            </template>
          </div>
          <div class="transaction_header-info">
            {{ formattedRefundAmount }}
          </div>
        </div>

        <div class="transaction_info">
          <div v-if="transaction.amount" class="info_box card-transfer">
            <div
              v-if="isCurrencyCrypto"
              class="info_box-title"
              v-text="$t('sent.to.wallet')"
            ></div>
            <div
              v-else
              class="info_box-title"
              v-text="$t('sent.to.card')"
            ></div>
            <div class="info_box-content">
              <span> {{ displayTransactionAmount }} </span>
            </div>
          </div>

          <div v-if="transaction.commission" class="info_box comission">
            <div class="info_box-title">{{ $t('commission.of.service') }}</div>
            <div class="info_box-content">
              <span>{{ displayTransactionCommission }}</span>
            </div>
          </div>

          <div v-if="transaction.account_number" class="info_box sender">
            <div class="info_box-title">{{ $t('common.recipient') }}</div>
            <div class="info_box-content">
              <span v-if="isApplePaymentMethod">
                {{ getFormattedAppleMethodName }}
              </span>
              <span v-else-if="isGooglePaymentMethod">
                {{ getFormattedGoogleAccountNumber }}
              </span>
              <span v-else-if="isCurrencyCrypto">
                {{ transaction.account_number }}
              </span>
              <span v-else>
                {{ getTransactionCardType }}
                {{ transaction.account_number | accountNumberShort }}
              </span>
              <p v-if="transaction.refund_email_recipient" class="text-textarea">
                {{ transaction.refund_email_recipient }}
              </p>
            </div>
          </div>

          <div v-if="transaction.description" class="info_box comment">
            <div class="info_box-title">{{ $t('common.description') }}</div>
            <div class="info_box-content">
              <p v-for="description in splitedDescription" :key="description">
                {{ description }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="isPersonalProject" class="transaction_footer">
          <a
            v-if="isShownRepeatPayoutButton"
            class="repeat"
            @click="$router.push({ name: 'payout', params: { transaction } })"
          >
            {{ $t('common.repeat') }}
          </a>
          <a
            class="receipt"
            :class="{ 'float-none': transaction.type === 'REFUND' }"
            @click.prevent="handleSendReceipt"
          >
            {{ $t('common.receipt') }}
          </a>
        </div>
      </template>
    </div>

    <div v-else class="transaction_block">
      <!-- ФИЛЬТР: ПЕРЕВОДЫ -->
      <template v-if="transactionTypeIs(transaction, 'orders')">
        <transfer-transaction-details
          :transaction="transaction"
          :permission="isPersonalProject"
          @close="CLOSE_TRANSACTION"
        />
      </template>

      <template v-if="transactionTypeIs(transaction, 'partner')">
        <partner-transaction-details
          :transaction="transaction"
          :permission="isPersonalProject"
          @close="CLOSE_TRANSACTION"
        />
      </template>

      <!-- ФИЛЬТР: СЧЕТА -->
      <template v-if="transactionTypeIs(transaction, 'bills')">
        <bill-card-header
          :transaction="transaction"
          :permission="isPersonalProject"
        />
        <bill-card-content
          :transaction="transaction"
          :permission="isPersonalProject"
        />
        <bill-card-footer
          v-if="isPersonalProject"
          :transaction="transaction"
          :permission="isPersonalProject"
        />
      </template>

      <!-- ФИЛЬТР: ВЫВОД СРЕДСТВ -->
      <template v-if="transactionTypeIs(transaction, 'payoutsAndRefunds')">
        <div class="transaction_header">
          <button class="transaction_block-close" @click="CLOSE_TRANSACTION">
            {{ $t('common.close') }}
          </button>

          <div class="transaction_header-title">
            {{ getTextByOrderType(transaction.type) }} — {{ transaction.created_at | date('DD.MM.YYYY HH:mm') }}
            <template v-if="transaction.public_parent_id && transaction.type === 'REFUND'">
              <br/> {{ $t('for.transfer.number', { publicId: transaction.public_parent_id }) }}
            </template>
          </div>
          <div class="transaction_header-info">
            {{ formattedRefundAmount }}
          </div>
        </div>

        <div class="transaction_info">
          <div v-if="transaction.amount" class="info_box card-transfer">
            <div
              v-if="isCurrencyCrypto"
              class="info_box-title"
              v-text="$t('sent.to.wallet')"
            ></div>
            <div
              v-else
              class="info_box-title"
              v-text="$t('sent.to.card')"
            ></div>
            <div class="info_box-content">
              <span> {{ displayTransactionAmount }} </span>
            </div>
          </div>

          <div v-if="transaction.commission" class="info_box comission">
            <div class="info_box-title">{{ $t('commission.of.service') }}</div>
            <div class="info_box-content">
              <span>{{ displayTransactionCommission }}</span>
            </div>
          </div>

          <div v-if="transaction.account_number" class="info_box sender">
            <div class="info_box-title">{{ $t('common.recipient') }}</div>
            <div class="info_box-content">
              <span v-if="isApplePaymentMethod">
                {{ getFormattedAppleMethodName }}
              </span>
              <span v-else-if="isGooglePaymentMethod">
                {{ getFormattedGoogleAccountNumber }}
              </span>
              <span v-else-if="isCurrencyCrypto">
                {{ transaction.account_number }}
              </span>
              <span v-else>
                {{ getTransactionCardType }}
                {{ transaction.account_number | accountNumberShort }}
              </span>
              <p v-if="transaction.refund_email_recipient" class="text-textarea">
                {{ transaction.refund_email_recipient }}
              </p>
            </div>
          </div>

          <div v-if="transaction.description" class="info_box comment">
            <div class="info_box-title">{{ $t('common.description') }}</div>
            <div class="info_box-content">
              <p v-for="description in splitedDescription" :key="description">
                {{ description }}
              </p>
            </div>
          </div>

          <!-- TODO: @danealton похоже это не используется -->
          <div v-if="transaction.billPromoCode">
            <bill-promo-code :content="getBillPromoCode" />
          </div>
        </div>

        <div v-if="isPersonalProject" class="transaction_footer">
          <a
            v-if="isShownRepeatPayoutButton"
            class="repeat"
            @click="$router.push({ name: 'payout', params: { transaction } })"
          >
            {{ $t('common.repeat') }}
          </a>
          <a
            class="receipt"
            :class="{ 'float-none': transaction.type === 'REFUND' }"
            @click.prevent="handleSendReceipt"
          >
            {{ $t('common.receipt') }}
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { isIOS } from 'mobile-device-detect';
import { mapState, mapGetters, mapMutations } from 'vuex';

import creditCardType from 'lib/utils/creditCardType';

import { getIconStyle, transactionTypeIs } from '@/services/mixins';

import { formatAmount } from 'lib/utils/amount';

import BillCardHeader from 'modules/Cards/BillCardHeader';
import BillCardContent from 'modules/Cards/BillCardContent';
import BillCardFooter from 'modules/Cards/BillCardFooter';

import PartnerTransactionDetails from 'organisms/transaction/details/PartnerTransactionDetails';
import TransferTransactionDetails from 'organisms/transaction/details/TransferTransactionDetails';

import { SUBSCRIPTION, TARIFF } from 'modules/Cards/const';

import TelegramInformationPanel from 'atoms/InformationPanels/TelegramInformationPanel';
import WidgetInformationPanel from 'atoms/InformationPanels/WidgetInformationPanel';
import ReportInformationPanel from 'atoms/InformationPanels/ReportInformationPanel';

import formatAccountNumber from './format-account-number';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TransactionInfo',
  mixins: [
    getIconStyle,
    transactionTypeIs,
  ],
  components: {
    BillCardHeader,
    BillCardContent,
    BillCardFooter,
    PartnerTransactionDetails,
    TransferTransactionDetails,
    TelegramInformationPanel,
    WidgetInformationPanel,
    ReportInformationPanel,
  },
  props: {
    transaction: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isIOS,
    };
  },
  computed: {
    currency() {
      return this.transaction.currency;
    },
    getAdditionalParams() {
      return this.transaction.additional_params && this.transaction.additional_params.length
        ? JSON.parse(this.transaction.additional_params)
        : null;
    },
    isSetupPayment() {
      if (this.$validate.isNull(this.getAdditionalParams)) {
        return false;
      }

      return this.getAdditionalParams.subscription_token_binding;
    },
    hasTildaCustomFields() {
      if (this.$validate.isNull(this.getAdditionalParams)) {
        return false;
      }

      const { details } = this.getAdditionalParams;
      if (this.$validate.isUndefined(details) || this.$validate.isNotObject(details)) {
        return false;
      }

      const { customFields } = details;
      if (this.$validate.isUndefined(customFields) || this.$validate.isEmptyString(customFields)) {
        return false;
      }

      return this.$validate.isNotEmptyObject(JSON.parse(customFields));
    },
    tildaCustomFields() {
      if (!this.hasTildaCustomFields) {
        return null;
      }

      const customFields = JSON.parse(this.getAdditionalParams.details.customFields);
      const formattedData = Object.keys(customFields).map(field => {
        return {
          name: field,
          value: customFields[field],
        };
      });

      return formattedData;
    },
    isApplePaymentMethod() {
      return this.transaction.payment_method && this.transaction.payment_method === 'APPLE';
    },
    isGooglePaymentMethod() {
      return this.transaction.payment_method && this.transaction.payment_method === 'GOOGLE';
    },
    isQiwiPaymentMethod() {
      return this.transaction.payment_method && this.transaction.payment_method === 'QIWI';
    },
    isYoomoneyPaymentMethod() {
      return this.transaction.payment_method && this.transaction.payment_method === 'YOOMONEY';
    },
    isPayMePaymentMethod() {
      return this.transaction.payment_method && this.transaction.payment_method === 'PAYME';
    },
    isYandexPayPaymentMethod() {
      return this.transaction.payment_method && this.transaction.payment_method === 'YANDEX';
    },
    isCryptoPaymentMethod() {
      return this.transaction.payment_method && this.transaction.payment_method === 'CRYPTO';
    },
    isRefundCompleted() {
      return this.transaction.status === 'REFUND_SUCCESS' || this.transaction.status === 'REFUND_PROCESSING';
    },
    hideReturnButton() {
      const isPurchase = this.transaction.type === 'PURCHASE' || this.transaction.type === 'PURCHASE_BILL' || this.transaction.type === 'REFUND_DEBIT';
      const isRefund = this.transaction.status === 'REFUND_SUCCESS' || this.transaction.status === 'REFUND_PROCESSING';

      return this.transaction.refundBanned || (isPurchase && isRefund);
    },
    getFormattedAppleMethodName() {
      if (!this.isApplePaymentMethod) {
        return '';
      }

      let method = this.transaction.payment_method;
      let methodName = method[0].toUpperCase() + method.toLowerCase().slice(1);

      return `${methodName} Pay`;
    },
    getFormattedGoogleAccountNumber() {
      if (!this.isGooglePaymentMethod) {
        return '';
      }

      const { account_number: accountNumber } = this.transaction;
      const { card_ps_type: cardPsType } = this.transaction;

      if (this.$validate.isNull(accountNumber)) {
        return '';
      }

      return formatAccountNumber(accountNumber, cardPsType);
    },
    getTransactionCardType() {
      const creditCardTypeArray = creditCardType(this.transaction.account_number);

      if (this.isApplePaymentMethod || this.isGooglePaymentMethod) {
        return this.transaction.card_ps_type;
      }

      if (this.$validate.isNull(this.transaction.account_number)) {
        return '';
      }

      if (this.$validate.isEmptyArray(creditCardTypeArray)) {
        return '';
      }

      return creditCardTypeArray[0].niceType;
    },
    getIconStyleClass() {
      if (this.$validate.isEmptyObject(this.transaction)) {
        return '';
      }

      return this.getIconStyle(this.transaction);
    },
    getMultiBillClass() {
      if (!this.transaction.multiBill) {
        return this.transaction.billPaymentEnabled ? '' : 'multi-off';
      }
      if (this.transaction.type === 'PURCHASE_BILL') {
        return '';
      }

      return this.transaction.billPaymentEnabled ? 'multi-on' : 'multi-off';
    },
    getBillTypeClass() {
      if (this.transaction.type === SUBSCRIPTION) {
        return 'subscription';
      }

      if (this.transaction.type === TARIFF) {
        return 'tariff';
      }

      return '';
    },
    transactionDeclaring() {
      return this.transaction.declared;
    },
    formattedAmount() {
      const { amount, commission } = this.transaction;

      return formatAmount(amount + commission, this.currency);
    },
    formattedRefundAmount() {
      const { amount, commission } = this.transaction;

      return `- ${formatAmount(amount + commission, this.currency)}`;
    },
    billTariffs() {
      const { billTariffs } = this.transaction;

      // @deprecated: в новом компоненте этого не будет
      if (this.$validate.isEmptyArray(billTariffs)) {
        return [{
          amount: this.transaction.billAmount || this.transaction.amount,
          currency: { ...this.transaction.currency },
        }];
      }

      return billTariffs;
    },
    preparedTariffs() {
      return this.billTariffs.map(tariff => {
        return {
          ...tariff,
          shown: false,
        };
      });
    },
    splitedDescription() {
      const { description } = this.transaction;

      if (!description) {
        return '';
      }

      return description.split('\n');
    },
    getBillPromoCode() {
      const { billPromoCode } = this.transaction;

      if (this.$validate.isNull(billPromoCode)) {
        return {};
      }

      return {
        amountWithDiscount: billPromoCode.amountWithDiscount,
        code: billPromoCode.code,
        currency: this.transaction.currency,
        discountAmount: billPromoCode.discountAmount,
        discountPercent: billPromoCode.discountPercent,
      };
    },
    isShownRepeatPayoutButton() {
      if (this.isExternalCheckoutProvider) {
        return false;
      }

      return this.transaction.type === 'PAYOUT';
    },

    displayTransactionAmount() {
      return formatAmount(this.transaction.amount, this.currency);
    },
    displayTransactionCommission() {
      return formatAmount(this.transaction.commission, this.currency);
    },
    isProcessingSafeDeal() {
      const { deal } = this.transaction;

      if (this.$validate.isNull(deal)) {
        return false;
      }

      return deal.status === 'OPENED' || deal.status === 'CHALLENGE_PROCESSING';
    },
    // eslint-disable-next-line complexity
    isCardOnly() {
      return ((this.transaction.account_number || this.isQiwiPaymentMethod || this.isYoomoneyPaymentMethod || this.isPayMePaymentMethod || this.isYandexPayPaymentMethod || this.isCryptoPaymentMethod) && !(this.transaction.senderProperties.name || this.transaction.senderProperties.email || this.transaction.senderProperties.phone || this.transaction.senderProperties.comment || this.transaction.senderProperties.message || this.transaction.senderProperties.address));
    },
    isShownRating() {
      const { rating } = this.transaction;

      if (!this.$validate.isObjectWithFields(rating, ['rating'])) {
        return false;
      }

      return this.$validate.isPositiveNumber(rating.rating);
    },
    cryptoAccrualCount() {
      return this.transaction.cryptoAccrualCount || 0;
    },
    cryptoTransactionHistoryLink() {
      return this.transaction.cryptoTransactionHistoryLink || null;
    },
    displayCryptoAccrual() {
      return this.$t('transaction.content.crypto.accrual', {
        count: this.cryptoAccrualCount,
      });
    },
    ...mapState([
      'SELECTED_TRANSACTION',
      'MERCHANT_INFO',
      'PROJECT_INFO',
      'SCROLL_STATES',
      'BINDED_CARDS',
      'TRANSACTIONS',
    ]),
    ...mapGetters([
      'payoutPermissionIsEnabled',
      'isSelfEmployedActivated',
      'isPersonalProject',
      'isExternalCheckoutProvider',
      'isCurrencyCrypto',
    ]),
  },
  methods: {
    // eslint-disable-next-line complexity
    getTextByOrderType(orderType) {
      switch (orderType) {
        case 'PAYOUT':
          return this.$t('common.withdrawal');
        case 'PURCHASE':
          return this.$t('common.transfer');
        case 'PURCHASE_BILL':
          return this.$t('common.transfer');
        case 'PARTNER_PAYOUT_ACCRUAL':
          return this.$t('common.transfer');
        case 'BILL':
          return this.$t('common.bill');
        case 'MULTIBILL':
          return this.$t('common.multibill');
        case 'SUBSCRIPTION':
          return this.$t('bill.subscription');
        case 'TARIFF':
          return this.$t('bill.tariff');
        case 'REFUND':
          return this.$t('common.refund');
        case 'CONFIRM_CARD':
          return this.$t('common.confirm.card');
        case 'REFUND_DEBIT':
          return this.$t('common.refund.debit');
        case 'SERVICE_DEBIT_MERCHANT':
          return this.$t('service.debit.merchant');
        default:
          return orderType;
      }
    },
    handleShownRefundConfirm() {
      EVENT_BUS.$emit('REFUND_CONFIRM', this.SELECTED_TRANSACTION.public_id);
    },
    handleClickSafeDealStatus() {
      EVENT_BUS.$emit('EVENT_SHOW_SAFE_DEAL_STATUS', this.transaction.deal);
    },
    handleSendReceipt() {
      EVENT_BUS.$emit('EVENT_SEND_TRANSACTION_RECEIPT', {
        url: this.PROJECT_INFO.payLink,
        title: `${this.$t('link.to.pay')} | capusta.space`,
        description: this.PROJECT_INFO.description,
        transactionId: this.SELECTED_TRANSACTION.public_id,
      });
    },
    ...mapMutations([
      'SELECT_TRANSACTION',
      'CLOSE_TRANSACTION',
    ]),
  },
};
</script>

<style lang="sass" module>
  .sender_info-layout
    +flexbox
    +align-items(flex-start)

  .sender_info-user-data
    flex-grow: 1

  .sender_info-rating
    flex: none
    margin-left: 10px

  .safeDealIcon
    display: inline-flex
    margin-right: 5px

    svg
      width: 16px
      height: 16px

      path
        fill: #fff
</style>

<style lang="sass" scoped>
  .cui-scrollbar-vertical.scroll-transaction
    position: absolute
    width: 0

  @mixin square($val)
    width: $val
    height: $val

  %icon-bg
    background:
      color: transparent
      repeat: no-repeat
      position: center

  %button-icon
    position: absolute
    +square(2rem)
    @extend %icon-bg

  .transaction
    position: sticky
    top: 0
    max-height: 100vh

    +adaptive(mobile)
      padding-bottom: 1rem

    +adaptive(laptop)
      max-width: 40rem
      margin: 0 auto

    +respond-to('medium')
      margin: 0 0 20px 20px

    &.arranger_is_fixed
      top: 66px

    .choose-transaction
      background: linear-gradient(220.58deg, rgba(91, 204, 126, 1) -8.32%, rgba(123, 211, 255, 1) 108.85%), rgba(255, 255, 255, 1)
      position: relative
      color: rgba(255,255,255, .7)
      padding: 4rem
      border-radius: 5px
      text-align: center

      #{theme('obsidian')} &
        &::after
          content: ''
          border-radius: 5px
          background: #27283C
          +full-size(1px)

      p
        position: relative
        z-index: 3

    .transaction-title
      margin: 0 0 10px
      line-height: 40px
      visibility: hidden

    .transaction_block
      border-radius: 0.36rem
      position: relative
      overflow: scroll
      overflow-x: hidden
      touch-action: pan-y
      max-height: 86vh
      -ms-overflow-style: none
      -webkit-overflow-scrolling: touch

      &::-webkit-scrollbar
        width: 0

      +adaptive(mobile)
        max-height: 86vh

      #{theme("eclipse")} &
        color: #212121
        background-color: $pure-white

      #{theme("obsidian")} &
        color: #212121
        background-color: #F2F2F2

      &-close
        @extend %button-icon
        font-size: 0
        line-height: 1.44rem
        top: 1.5rem
        right: 2rem
        background-image: get-icon(close, #fff, $misc)
        background-size: 100%
        transition: .2s ease
        +adaptive(mobile-xl)
          right: 1rem
          z-index: 4

        &:hover
          transform: scale(.9)

    &.bill

      .transaction_block-close
        background-image: get-icon(close, #212121, $misc)

  @mixin contentIcons($icon, $color: #212121)
    &::before
      background-image: get-icon($icon, $color, $transactionsContentIcons)

  // ICONS
  .comission
    +contentIcons(percent)

  .description
    +contentIcons(description)

  .multi-transaction
    +contentIcons(payment)

    .multi-off &
      &::before
        opacity: .5

  .transaction-link
    +contentIcons(link)

  .sender
    +contentIcons(user)

    &.card-only::before
      top: 1.3rem !important
      +adaptive(mobile)
        top: 1.7rem !important

  .declaring
    +contentIcons(declare-on)

    &:not(.approved)
      +contentIcons(declare-off)

  .card-transfer
    +contentIcons(card)

  .comment
    +contentIcons(comment)

  .discount
    +contentIcons(discount)

  // icons array: transactionHeaderIcons
  // function: get-icon($icon, $color: #fff, $array: $icons)

  @mixin headerIcons($icon, $color: #212121)
    &::before
      background-image: get-icon($icon, $color, $transactionHeaderIcons)
      background-repeat: no-repeat

  .transaction_header
    padding: 2rem
    padding-left: 5.6rem
    font-weight: 600
    +adaptive(mobile)
      padding-right: 1rem
      padding-left: 4rem
      padding-bottom: 1.5rem
    +adaptive(laptop-start)
      position: sticky
      top: 0
      z-index: 3

    &::before
      @extend %button-icon
      content: ''
      left: 2rem
      top: 1.5rem
      .transfer &
        top: 1.7rem
      +adaptive(mobile)
        left: 1rem

    &-title
      font-size: .9rem
      padding-bottom: .5rem
      padding-right: 1.5rem

    &-info
      font-size: 1.4rem

    .transaction_header-info.editable
      display: inline-block
      cursor: pointer

      .amount_wrapper
        border-bottom: 1px solid #1e1d2f

      .pencil
        background-image: get-icon(pencil, black)
        background-repeat: no-repeat
        display: inline-block
        vertical-align: text-top
        margin-left: 2px
        width: 20px
        height: 20px

    // .bill &
    //   background: linear-gradient(39.13deg, rgba(252, 212, 0, 1) 0%, rgba(254, 135, 26, 1) 100%), rgba(255, 255, 255, 1)
    //   +headerIcons(bill)

    // .multi-on &
    //   +headerIcons(multi-on)

    // .multi-off &
    //   +headerIcons(multi-off)
    //   filter: grayscale(1)

    .marketplace-on &
      +headerIcons(multi-on)

    .marketplace-off &
      +headerIcons(multi-off)
      filter: grayscale(1)

    .transfer &
      background: linear-gradient(220.58deg, rgba(91, 204, 126, 1) -8.32%, rgba(123, 211, 255, 1) 108.85%), rgba(255, 255, 255, 1)
      +headerIcons(transfer, #fff)
      color: #fff

      .transaction_header-info.processing-safe-deal
        display: flex
        align-items: center
        opacity: .7

    .withdrawal &,
    .refund &
      background: linear-gradient(39.13deg, rgba(255, 107, 140, 1) 0%, rgba(254, 143, 122, 1) 100%), rgba(255, 255, 255, 1)
      color: #fff

    .withdrawal &
      +headerIcons(withdraw, #fff)

    .refund &
      +headerIcons(refund, #fff)

  .transaction_info
    padding: 0 2rem

    +adaptive(mobile)
      padding: 0 1rem

  .info_box
    position: relative
    padding: 1.4rem 2rem 1.4rem 3.6rem

    +adaptive(mobile)
      padding: 1.8rem 2rem 1.8rem 3rem

    &:not(:first-child)
      border-top: 0.08rem solid #E3E3E4

    &::before
      @extend %button-icon
      content: ''
      left: 0
      top: 1rem

      +adaptive(mobile)
        top: 1.3rem

    &.sender
      padding-right: 0
      border-bottom: 1px solid #E3E3E4

    &.discount
      padding-right: 0

    &.declaring
      cursor: pointer

      &:not(.approved)
        padding-right: 0
        +adaptive(mobile)
          padding-right: 1rem

      &::before
        top: 50%
        margin-top: -1rem

      button
        margin-top: -1rem !important

    &.qiwi,
    &.yoomoney
      margin-left: 3.6rem
      padding-left: 0

      & .info_box-title
        font-weight: 500
        font-size: 20px
        color: #000

    .info_box-title + .info_box-content
      padding-top: .6rem

      .link_to_content
        margin-top: 8px
        font-size: 1.1rem
        vertical-align: middle

        &::before
          content: ''
          background: get-icon(clip, #333) no-repeat
          background-size: contain
          display: inline-block
          vertical-align: middle
          width: 20px
          height: 15px

    &-title
      font-size: .9rem
      color: #898989

    &-content
      word-break: break-word
      font-weight: 500
      font-size: 1rem
      position: relative

      i
        font-style: normal

      a
        color: #000

        &:not(.button)
          text-decoration: underline

          &:hover
            text-decoration: none
      span
        font-size: 1.4rem

      .button > span
        font-size: 1rem

      p
        font-size: .9rem

      button
        @extend %button-icon
        right: -2rem
        top: 50%
        margin-top: -.6rem
        font-size: 0

    .info_box-label
      font-size: 1rem
      font-weight: 500
      color: #9B51E0

  .icon-multi-on
    background-image: get-icon(multi-on, #9B51E0, $transactionHeaderIcons)

  .icon-multi-off
    background-image: get-icon(multi-off, #9B51E0, $transactionHeaderIcons)

  .icon-receipt
    background-image: get-icon(receipt, #9B51E0, $misc)

  .icon-copy
    background-image: get-icon(copy, #9B51E0, $transactionFooterIcons)

  .sender_info
    margin: 0 !important
    padding: 0 !important
    +adaptive(mobile-xl)
      margin-bottom: 0 !important

    li
      word-break: break-word

      &:not(:last-child)
        margin-bottom: .3rem

      &[data-sender="name"]
        font-weight: 600

      &[data-sender="email"]
        a
          color: #9B51E0

      &[data-sender="info-bubble"]
        background-color: rgba(33,33,33, .1)
        padding: 1.5rem
        border-radius: 8px
        border-top-left-radius: 0
        font-size: .9rem
        margin-top: 1.4rem
        font-weight: 500
        word-break: break-all

      &[data-sender="card"],
      &[data-sender="qiwi"],
      &[data-sender="yoomoney"],
      &[data-sender="payme"],
      &[data-sender="yandex"],
      &[data-sender="crypto"]
        font-size: 1.4rem
        font-weight: 500

        &:not(:first-child)
          margin-top: 1.4rem
          padding-top: 1.4rem
          border-top: 0.08rem solid #E3E3E4

      &[data-sender="crypto"]
        font-size: 14px

  .transaction_footer
    border-top: 0.08rem solid #E3E3E4
    padding: 2rem
    display: flex
    justify-content: space-between
    +adaptive(mobile)
      padding: 1.5rem 1rem

    .invisible
      display: none

    a
      color: #9B51E0
      display: flex
      align-items: center
      font-weight: 600
      transition: .2s ease

      .bill &
        font-size: 0
        padding: 0 2rem

      &::before
        content: ''
        display: inline-block
        transition: .2s ease
        +square(2rem)
        @extend %icon-bg

        .transaction:not(.bill) &
          margin-right: 1.3rem
          +adaptive(mobile)
            margin-right: .9rem

      $buttons: ( copy: copy, code: code, share: share, return: backward, receipt: receipt, repeat: repeat, backward: backward-done)

      @each $class, $icon in $buttons
        &.#{$class}
          &::before
            background-image: get-icon($icon, #9B51E0, $transactionFooterIcons)

      &.backward
        color: #FF5172
        text-decoration: underline

        &::before
          background-image: get-icon(backward-done, #FF5172, $transactionFooterIcons) !important

  .loading-declaration
    width: 100%
    height: 10px
    margin: 15px 0
    position: relative
    overflow: hidden
    border-radius: 50px
    background: rgba(33, 33, 33, 0.1)

    .loader
      width: 50px
      height: 100%
      position: absolute
      top: 0
      left: 0
      background: #1e1d2f
      border-radius: 50px
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15)
      animation: 2s infinite slideInFromLeft

  @keyframes slideInFromLeft
    0%
      left: 0
    100%
      left: 100%
</style>
